import React from 'react';
import { Chevron } from 'assets/svgs';
import Container from 'components/Container/Container';
import UI from 'constants/ui';
import Link from 'next/link';

import { Flex } from '../Flex';

import { BackButton, PageHeaderWrapper, PageName } from './styles';

interface PageHeaderProps {
  pageName: string;
  goBack?: string;
  capitalize?: boolean;
  truncateText?: boolean;
  className?: string;
}

const PageHeader = ({
  goBack = '',
  pageName,
  capitalize = false,
  truncateText,
  className = '',
}: PageHeaderProps) => {
  const padding = {
    mobile: `0 ${UI.page.padding.mobile}`,
    desktop: `0 ${UI.page.padding.desktop}`,
  };

  return (
    <PageHeaderWrapper className={className}>
      <Container padding={padding}>
        <Flex align="center" gap="1rem">
          {goBack && (
            <Link href={goBack} passHref>
              <BackButton>
                <Chevron direction="left" />
              </BackButton>
            </Link>
          )}
          <PageName $capitalize={capitalize} $truncateText={truncateText}>
            {pageName}
          </PageName>
        </Flex>
      </Container>
    </PageHeaderWrapper>
  );
};

export default PageHeader;
